// vuex
import { mapState, mapMutations } from 'vuex';

export default {
	data() {
		return {
			isOpenStatus: false
		};
	},
	computed: {
		...mapState('customers', [
			'customersAccordionStatuses',
			'companiesAccordionStatuses'
		])
	},
	methods: {
		...mapMutations('customers', ['updateAccordionStatuses']),
		openStatusStored(name, id) {
			if (Array.isArray(this[name])) {
				return this[name].includes(id);
			}
			return false;
		},
		collapse() {
			this.isOpenStatus = false;
		}
	}
};
